/**
 * 채널 탭별 고정 문구 — 라벨·VAT·귀속 창 이름·연동 페이지(설계 §3.2·§3.4).
 *
 * 탭은 **서버 게이트가 연 채널만** 둔다(`v2/ad_performance/gate.py` `DASHBOARD_PERFORMANCE_CHANNELS`).
 * 1차는 메타뿐이다. 채널을 열 때 서버 튜플과 여기를 함께 늘린다 — 여기만 늘리면 탭이 404 로 떨어진다.
 *
 * ⭐ 전환 칸은 전 채널 `conversions`/`conversion_value` 한 쌍만 읽고 **라벨만** 채널별로 바꾼다(§3.4).
 */

export interface ChannelConfig {
  channel: string
  /** 탭 이름 */
  label: string
  /** 연동 상태를 볼 페이지 */
  setupTo: '/setup/meta-ads'
  /** 광고비 VAT 기준 — 1차 출처 근거는 설계 §3.2 표 */
  vat: string
  labels: { conversions: string; conversionValue: string }
  /** 귀속 창 stamp → 문구. 표에 없는 stamp 는 원문 그대로(조용히 숨기지 않는다) */
  windowLabels: Record<string, string>
}

export const CHANNELS: ChannelConfig[] = [
  {
    channel: 'meta',
    label: '메타',
    setupTo: '/setup/meta-ads',
    vat: 'VAT 제외',
    labels: { conversions: '구매', conversionValue: '구매 금액' },
    // 수집기가 요청하는 창(`ad_daily_insights.attribution_window_value`)
    windowLabels: { '7d_click_1d_view': '클릭 후 7일·조회 후 1일' },
  },
]

export function findChannel(channel: string): ChannelConfig | undefined {
  return CHANNELS.find((c) => c.channel === channel)
}
